import { render, staticRenderFns } from "./formmask.vue?vue&type=template&id=2d4217bb&scoped=true&lang=html&"
import script from "./formmask.vue?vue&type=script&lang=js&"
export * from "./formmask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4217bb",
  null
  
)

export default component.exports